import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { logErrorToServerside } from '../services/serverSideLogging';
import { ApplicationError } from '@n2-common/services/errors';

export function ReactRouterErrorBoundary() {
    const error = useRouteError();

    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            return <div>This page doesn't exist!</div>;
        }

        if (error.status === 401) {
            return <div>You aren't authorized to see this</div>;
        }

        if (error.status === 503) {
            return <div>Looks like our API is down</div>;
        }

        if (error.status === 418) {
            return <div>🫖</div>;
        }
    }
    if (error instanceof ApplicationError) {
        logErrorToServerside(error.message, error.applicationId, error.applicantId, error);
    } else {
        logErrorToServerside('General error caught in error-boundary', '', '', error);
    }

    return <div>Something went wrong</div>;
}
